import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getGraphPresetStateByKey } from './selectors';
import { GraphPresetState, GraphPresetStateByKey, initialGraphPresetState, initialGraphPresetStateByKey } from './state';

type SetGraphPresetAction = {
  id: number;
  preset: GraphPresetStateByKey;
};

type UpdateGraphPresetAction = {
  id: number;
  changes: Partial<GraphPresetStateByKey>;
};

const graphPresetSlice = createSlice({
  name: 'graph-preset',
  initialState: initialGraphPresetState,
  reducers: {
    reset: () => initialGraphPresetState,
    setPreset: (state: GraphPresetState, action: PayloadAction<SetGraphPresetAction>) => {
      const key = action.payload.id;
      state[key] = {
        ...initialGraphPresetStateByKey,
        ...action.payload.preset,
        updatedTimestamp: Date.now()
      };
    },
    updatePreset: (state: GraphPresetState, action: PayloadAction<UpdateGraphPresetAction>) => {
      const key = action.payload.id;
      const currState = state[key] || getGraphPresetStateByKey(key, state);
      state[key] = {
        ...currState,
        ...action.payload.changes,
        updatedTimestamp: Date.now()
      };
    }
  }
});

const { actions, reducer } = graphPresetSlice;
export const { reset, setPreset, updatePreset } = actions;
export default reducer;
